<template>
  <div :class="typeClass">
    <div class="attached-document--icon elevation-2">
      <v-menu
        v-if="!readonly"
        right offset-y
        nudge-top="30px" origin="center center" transition="scale-transition">
        <v-btn
          icon small dark
          fab slot="activator" class="ma-0 pa-0"
          color="secondary" style="z-index:1; width:28px; height:28px; top:-6px !important; right:-24px !important">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list dense>
          <v-list-tile v-if="openable" @click="$emit('view-file-to-side')">
            <v-icon class="mr-2" color="secondary">vertical_split</v-icon>
            Open to the side
          </v-list-tile>
          <v-list-tile v-if="openable" @click="$emit('view-file')">
            <v-icon class="mr-2" color="secondary">open_in_browser</v-icon>
            Open in new tab
          </v-list-tile>
          <v-list-tile v-if="openable" @click="$emit('view-in-documents-tab')">
            <v-icon class="mr-2" color="secondary">insert_drive_file</v-icon>
            View on Documents Tab
          </v-list-tile>
          <!-- <v-list-tile @click="$emit('send-file')">
            <v-icon class="mr-2" color="secondary">send</v-icon>
            Move
          </v-list-tile> -->
          <v-list-tile @click="$emit('copy-file')">
            <v-icon class="mr-2" color="secondary">content_copy</v-icon>
            Duplicate
          </v-list-tile>
          <v-list-tile @click="$emit('download-file')">
            <v-icon class="mr-2" color="secondary">file_download</v-icon>
            Download
          </v-list-tile>
          <v-list-tile v-if="!currentlySelected" @click="$emit('rename-file')">
            <v-icon class="mr-2" color="secondary">create</v-icon>
            Rename
          </v-list-tile>
          <v-list-tile v-if="!currentlySelected" @click="$emit('delete-file')" color="error">
            <v-icon class="mr-2" color="error">delete</v-icon>
            Delete
          </v-list-tile>
          <v-list-tile v-if="currentlySelected && !isField" @click="$emit('delete-file')" color="error">
            <v-icon class="mr-2" color="error">remove</v-icon>
            Remove from case
          </v-list-tile>
          <v-list-tile v-if="currentlySelected && isField" @click="$emit('clear-field')" color="error">
            <v-icon class="mr-2" color="error">remove_circle</v-icon>
            Remove
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
    <span class="doc-name">{{filetype}}</span>
    <p>{{filename}}</p>
  </div>
</template>

<script>
export default {
  name: "document-icon",
  props: {
    filename: { type: String, required: true },
    filetype: { type: String, required: true },
    route: { type: String },
    readonly: { type: Boolean, default: false },
    currentlySelected: { type: Boolean, default: false },
    isField: { type: Boolean, required: true }
  },
  computed: {
    openable() {
      switch (this.filetype.toLowerCase()) {
        case ".bmp":
        case ".gif":
        case ".jpg":
        case ".jpeg":
        case ".svg":
        case ".png":
        case ".pdf":
          return true
        default:
          return false
      }
    },
    typeClass() {
      if (this.filetype) {
        const type = this.filetype.replace(".", "")
        return "attached-document " + type.toLowerCase() + " mb-3"
      } else {
        return ""
      }
    }
  }
}
</script>

<style scoped>
.attached-document.pdf .attached-document--icon {
  background: #af0505;
}

.attached-document.jpg .attached-document--icon,
.attached-document.jpeg .attached-document--icon,
.attached-document.tiff .attached-document--icon,
.attached-document.tga .attached-document--icon,
.attached-document.png .attached-document--icon,
.attached-document.gif .attached-document--icon,
.attached-document.bmp .attached-document--icon {
  background: #257f7f;
}

.attached-document.ai .attached-document--icon,
.attached-document.eps .attached-document--icon {
  background: #ff791a;
}

.attached-document.psd .attached-document--icon {
  background: #00c8ff;
}
.attached-document.pptx .attached-document--icon,
.attached-document.ppt .attached-document--icon {
  background: #a92b1a;
}

.attached-document.doc .attached-document--icon,
.attached-document.docx .attached-document--icon {
  background: #2b579a;
}

.attached-document.dmg .attached-document--icon,
.attached-document.iso .attached-document--icon {
  background: #d59731;
}

.attached-document.otp .attached-document--icon,
.attached-document.odf .attached-document--icon {
  background: #f38739;
}

.attached-document--icon,
.attached-document.odt .attached-document--icon,
.attached-document.ott .attached-document--icon {
  background: #0e85cd;
}

.attached-document.tgz .attached-document--icon,
.attached-document.zip .attached-document--icon {
  background: #f0d05f;
}

.attached-document.rar .attached-document--icon {
  background: #bc5eb0;
}

.attached-document.ics .attached-document--icon {
  background: #d33333;
}

.attached-document.key .attached-document--icon {
  background: #db7a2a;
}

.attached-document.xls .attached-document--icon,
.attached-document.xlsx .attached-document--icon {
  background: #14662d;
}

.attached-document.dwg .attached-document--icon,
.attached-document.dxf .attached-document--icon {
  background: #06a3d6;
}

.attached-document.ods .attached-document--icon,
.attached-document.ots .attached-document--icon,
.attached-document.dotx .attached-document--icon {
  background: #a9cc27;
}

.attached-document.avi .attached-document--icon,
.attached-document.flv .attached-document--icon,
.attached-document.qt .attached-document--icon,
.attached-document.mp4 .attached-document--icon,
.attached-document.mpg .attached-document--icon {
  background: #8a3681;
}

.attached-document.aac .attached-document--icon,
.attached-document.aiff .attached-document--icon,
.attached-document.mid .attached-document--icon,
.attached-document.mp3 .attached-document--icon,
.attached-document.wav .attached-document--icon {
  background: #575dad;
}

.attached-document.c .attached-document--icon,
.attached-document.cpp .attached-document--icon,
.attached-document.css .attached-document--icon,
.attached-document.dat .attached-document--icon,
.attached-document.default .attached-document--icon,
.attached-document.exe .attached-document--icon,
.attached-document.h .attached-document--icon,
.attached-document.hpp .attached-document--icon,
.attached-document.html .attached-document--icon,
.attached-document.java .attached-document--icon,
.attached-document.js .attached-document--icon,
.attached-document.less .attached-document--icon,
.attached-document.php .attached-document--icon,
.attached-document.py .attached-document--icon,
.attached-document.rb .attached-document--icon,
.attached-document.rtf .attached-document--icon,
.attached-document.sass .attached-document--icon,
.attached-document.scss .attached-document--icon,
.attached-document.sql .attached-document--icon,
.attached-document.txt .attached-document--icon,
.attached-document.xml .attached-document--icon,
.attached-document.yml .attached-document--icon {
  background: #bdb7b7;
}
</style>
